import { useMemo } from "react";

const useDocumentStatus = (uploadedDocuments) => {
  const normalizedApprovalStatus = useMemo(() => {
    return uploadedDocuments
      ? uploadedDocuments.map((document) => ({
          ...document,
          documentApprovalStatus: document?.documentApprovalStatus ?? "PENDING",
        }))
      : [];
  }, [uploadedDocuments]);

  const disapprovedDocuments = useMemo(() => {
    return normalizedApprovalStatus.some(
      (document) => document.documentApprovalStatus === "FAILED",
    );
  }, [normalizedApprovalStatus]);

  const approvedDocuments = useMemo(() => {
    return normalizedApprovalStatus.length > 0 && normalizedApprovalStatus.every(
      (document) => document.documentApprovalStatus === "APPROVED",
    );
  }, [normalizedApprovalStatus]);

  const hasPendingDocuments = useMemo(() => {
    return normalizedApprovalStatus.some(
      (document) => document.documentApprovalStatus === "PENDING",
    );
  }, [normalizedApprovalStatus]);

  return {
    disapprovedDocuments,
    approvedDocuments,
    hasPendingDocuments,
  };
};

export default useDocumentStatus;
